import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Box,
  Link,
  IconButton,
  Icon,
  ButtonBase,
  CircularProgress,
} from '@material-ui/core';

import EmptyAvatar from '../../../components/AvatarProfile';
import useStyles from './styles';

const Avatar = ({ avatar, uploadAvatar, removeAvatar, loadingAvatar }) => {
  const classes = useStyles();
  const [img, setImg] = useState(avatar || '');
  const input = useRef(null);

  useEffect(() => {
    setImg(avatar);
  }, [avatar]);

  const handleRemoveImg = useCallback(() => {
    window.URL.revokeObjectURL(img);
    input.current.value = '';
    setImg('');
    removeAvatar();
  }, [img, removeAvatar]);

  const handleChangeImg = useCallback(() => {
    if (input.current.files.length > 0) {
      setImg(URL.createObjectURL(input.current.files[0]));
      uploadAvatar(input.current.files[0]);
    } else {
      setImg('');
    }
  }, [uploadAvatar]);

  const handleTriggerClick = useCallback(() => input.current.click(), []);

  return (
    <Box className={classes.container}>
      <Box className="avatar-wrapper">
        {loadingAvatar && (
          <CircularProgress className="avatar-loading" color="inherit" />
        )}
        {img ? (
          <Box className="avatar-button">
            <ButtonBase onClick={handleTriggerClick}>
              <EmptyAvatar size="large" avatar={img} />
            </ButtonBase>
            <IconButton
              className="remove-button"
              size="small"
              onClick={handleRemoveImg}
            >
              <Icon fontSize="small">close</Icon>
            </IconButton>
          </Box>
        ) : (
          <ButtonBase className="avatar-button" onClick={handleTriggerClick}>
            <EmptyAvatar size="large" />
          </ButtonBase>
        )}
      </Box>
      <Link
        className="link-button"
        variant="caption"
        color="secondary"
        underline="always"
        onClick={handleTriggerClick}
      >
        Selecionar imagem
      </Link>
      <input
        id="avatar-input"
        type="file"
        onChange={handleChangeImg}
        ref={input}
      />
    </Box>
  );
};

export default Avatar;
